import * as globals from '@wandb/common/css/globals.styles';
import styled from 'styled-components';

export const PageWithSidebar = styled.div`
  display: flex;

  @media only screen and (max-width: ${globals.TABLET_BREAKPOINT}) {
    display: block;
  }
`;
PageWithSidebar.displayName = 'S.PageWithSidebar';

export const Sidebar = styled.div`
  background-color: white;
  border-right: 1px solid ${globals.GRAY_300};

  min-height: calc(
    100vh - ${globals.SEARCH_NAV_HEIGHT}
  ); // account for top nav bar
  width: 300px;
  max-width: 300px;
  padding: 16px 12px !important;
  flex-shrink: 0;

  @media only screen and (max-width: ${globals.TABLET_BREAKPOINT}) {
    min-height: 100%;
    min-width: 100vw;
    border-right: unset;
    border-bottom: 1px solid ${globals.GRAY_300};
  }
`;
Sidebar.displayName = 'S.Sidebar';

export const Content = styled.div`
  overflow: hidden;
  width: 100%;
  padding: 16px 40px;

  @media only screen and (max-width: ${globals.TABLET_BREAKPOINT}) {
    padding: 16px 24px;
  }
`;
Content.displayName = 'S.Content';
